const AUTH_REDIRECT_STORAGE_KEY = 'monorga:redirect_to'

/** Après `login()`, le retour OIDC peut passer `loggedIn` de `undefined` à `true` sans jamais `false` : on pose ce flag pour afficher le toast de connexion. */
const LOGIN_TOAST_PENDING_KEY = 'monorga:pending_login_toast'

/** Avant `logout()` : la redirection SSO peut recharger la page sans transition `loggedIn` observable sur la même instance. */
const LOGOUT_TOAST_PENDING_KEY = 'monorga:pending_logout_toast'

function isClient(): boolean {
  return typeof window !== 'undefined'
}

function isSafeInternalPath(value: string): boolean {
  return value.startsWith('/') && !value.startsWith('//')
}

function decodePath(value: string): string {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export function normalizeAuthRedirectPath(value: string | null | undefined): string | null {
  if (!value) return null
  const decodedOnce = decodePath(value)
  const normalized = decodedOnce.includes(' ') ? encodeURI(decodedOnce) : decodedOnce
  if (!isSafeInternalPath(normalized)) return null
  return normalized
}

export function storeAuthRedirectTarget(path: string): void {
  if (!isClient()) return
  const normalized = normalizeAuthRedirectPath(path)
  if (!normalized) return
  sessionStorage.setItem(AUTH_REDIRECT_STORAGE_KEY, normalized)
}

export function consumeAuthRedirectTarget(): string | null {
  if (!isClient()) return null
  const value = sessionStorage.getItem(AUTH_REDIRECT_STORAGE_KEY)
  if (!value) return null
  sessionStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY)
  return normalizeAuthRedirectPath(value)
}

export function setPendingLoginToast(): void {
  if (!isClient()) return
  sessionStorage.setItem(LOGIN_TOAST_PENDING_KEY, '1')
}

/**
 * Indique qu’un toast « connexion réussie » doit être affiché après le passage à connecté.
 * À appéler une seule fois après consommation du flag.
 */
export function consumePendingLoginToast(): boolean {
  if (!isClient()) return false
  const value = sessionStorage.getItem(LOGIN_TOAST_PENDING_KEY)
  if (value !== '1') return false
  sessionStorage.removeItem(LOGIN_TOAST_PENDING_KEY)
  return true
}

export function setPendingLogoutToast(): void {
  if (!isClient()) return
  sessionStorage.setItem(LOGOUT_TOAST_PENDING_KEY, '1')
}

export function consumePendingLogoutToast(): boolean {
  if (!isClient()) return false
  const value = sessionStorage.getItem(LOGOUT_TOAST_PENDING_KEY)
  if (value !== '1') return false
  sessionStorage.removeItem(LOGOUT_TOAST_PENDING_KEY)
  return true
}

